import React from 'react'
import usePageMeta from '../hooks/usePageMeta'
import Navbar from '../components/navbar/Navbar'
import TutionHeader from '../components/header_tution/TutionHeader'
import Footer from '../components/footer/Footer'
import Tution from '../components/tution/Tution'

export default function TutionPage() {
  usePageMeta({
    title: 'Tuition & Rates | Learning In Motion Academy, Tamarac FL',
    description: 'Tuition and program rates for infant care, toddler, preschool and VPK at Learning In Motion Academy in Tamarac, FL.',
    path: '/tuition',
  })

  return (
    <>
      <Navbar/>
      <TutionHeader/>
      <Tution/>
      <Footer/>
    </>
  )
}
